var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50313 0.5L9.50313 2H15.5031V4.5H14.5031V3H9.16875L8.90312 2.8L7.16875 1.5H1.50312V10.4125L2.93125 6H17.5031L17.1781 7L15.0719 13.5H0.5V0.5H7.5H7.50313ZM8.50313 12.5H14.3469L16.1281 7H3.65937L1.87812 12.5H8.50313Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderNotificationIcon);
export default __webpack_public_path__ + "static/media/folder-notification-icon.d345af25d4b194a43208c6ea2bd0d025.svg";
export { ForwardRef as ReactComponent };